import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { c as a } from "../../../index-CROKJrb5.js";
import { c as m, f as p } from "../../../create-component-CBAeEoQ6.js";
import { IconRenderer as b } from "../../Icon/index.js";
import { Typography as u } from "../../Typography/index.js";
const v = (r) => typeof r == "string" ? r : void 0, w = a({
  base: "cur-flex cur-gap-2 cur-p-4 cur-align-start",
  variants: {
    state: {
      highlight: "cur-bg-surface-highlight cur-text-brand",
      critical: "cur-bg-surface-error cur-text-error",
      warning: "cur-bg-surface-warning cur-text-warning",
      success: "cur-bg-surface-success cur-text-success",
      light: "cur-bg-surface-neutral",
      dark: "cur-bg-surface-secondary cur-text-white"
    }
  }
}), j = a({
  base: "cur-flex cur-flex-col cur-grow cur-gap-1",
  variants: {
    iconSize: {
      xs: "",
      sm: "-cur-mt-1",
      md: "",
      lg: "",
      xl: "",
      xxl: ""
    }
  }
}), L = a({
  variants: {
    state: {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      highlight: "cur-text-subtle",
      critical: "cur-text-subtle",
      warning: "cur-text-subtle",
      success: "cur-text-subtle",
      light: "cur-text-subtle",
      dark: "cur-text-disabled"
    }
  }
}), C = a({
  variants: {
    state: {
      highlight: "cur-fill-brand",
      critical: "cur-fill-error",
      warning: "cur-fill-warning",
      success: "cur-fill-success",
      light: "cur-fill",
      dark: "cur-fill-inverse"
    }
  }
}), I = m(
  "Toast",
  p(
    ({
      as: r,
      children: t,
      className: n,
      icon: l,
      iconSize: i,
      onClose: o,
      state: e = "light",
      title: c,
      toastId: g,
      ...x
    }, f) => {
      const h = r || "div", d = j({
        iconSize: v(i)
      });
      return /* @__PURE__ */ s.jsxs(
        h,
        {
          as: r,
          ref: f,
          className: w({ state: e, className: n }),
          state: e,
          ...x,
          "data-toastid": g,
          role: "alert",
          children: [
            l && /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(b, { icon: l, size: i }) }),
            /* @__PURE__ */ s.jsxs("div", { className: d, children: [
              c && typeof c == "string" ? /* @__PURE__ */ s.jsx(u, { size: "subhead", className: "cur-font-bold", children: c }) : c,
              t && typeof t == "string" ? /* @__PURE__ */ s.jsx(u, { size: "meta", className: L({ state: e }), children: t }) : t
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "cur-flex cur-grow-0", children: /* @__PURE__ */ s.jsx(
              "button",
              {
                type: "button",
                title: "Close toast",
                onClick: o,
                className: "cur-h-auto cur-self-start cur-p-2",
                children: /* @__PURE__ */ s.jsx(
                  "svg",
                  {
                    className: C({ state: e }),
                    width: "8",
                    height: "8",
                    viewBox: "0 0 8 8",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ s.jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M4 5.41433L1.87868 7.53565L0.464466 6.12144L2.58579 4.00012L0.464466 1.8788L1.87868 0.464582L4 2.5859L6.12132 0.464582L7.53553 1.8788L5.41421 4.00012L7.53553 6.12144L6.12132 7.53565L4 5.41433Z",
                        fill: "inherit"
                      }
                    )
                  }
                )
              }
            ) })
          ]
        }
      );
    }
  )
);
export {
  I as ToastItem
};
//# sourceMappingURL=index.js.map
